import { useQuery } from '@tanstack/react-query';
import { quotesApi } from '@/lib/api/client';

export const marketStatusKeys = {
  all: ['marketStatus'] as const,
};

export function useMarketStatus() {
  return useQuery({
    queryKey: marketStatusKeys.all,
    queryFn: () => quotesApi.getMarketStatus(),
    // Refresh every 5 minutes — market status doesn't change often
    refetchInterval: 5 * 60 * 1000,
    staleTime: 2 * 60 * 1000,
  });
}
